// src/belediye/components/mesajlasma/Avatar.js
// Kurumsal avatar — fotoğraf varsa görsel, yoksa baş-harf rozeti (sistem
// kullanıcı/personel ekranlarındaki convention ile aynı; navbar avatarı 36px).
// Renk baş-harften türetilir (sabit palet — temaya uyumlu, rastgele değil).

import React from "react";

const PALET = [
  "#1f2a40", "#314a6b", "#2e6b5e", "#7c5a2e", "#5b3a6b", "#8a3b52", "#2e5a7c",
];

const basHarf = (isim) =>
  (String(isim || "").trim() || "?").slice(0, 1).toLocaleUpperCase("tr");

// Profil fotoğrafı URL çözümü: backend kök-göreli "/media/..." verir; frontend
// origin'i backend'den FARKLI olabilir → BACKEND_ORIGIN öneki (vatandaş medya
// deseniyle aynı). Mutlak URL'e (http...) dokunmaz; env yoksa aynen bırakır.
const BACKEND_ORIGIN = String(process.env.REACT_APP_BACKEND_URL || "").replace(/\/api\/?$/, "");
const resolveSrc = (src) =>
  src && typeof src === "string" && src.startsWith("/") ? `${BACKEND_ORIGIN}${src}` : src;

const renkIndex = (isim) => {
  const s = String(isim || "");
  let acc = 0;
  for (let i = 0; i < s.length; i += 1) acc = (acc + s.charCodeAt(i)) % PALET.length;
  return acc;
};

export default function Avatar({ name, src, size = 34, title }) {
  const boyut = { width: size, height: size, fontSize: Math.round(size * 0.42) };
  if (src) {
    return (
      <img
        className="msj-avatar"
        src={resolveSrc(src)}
        alt={name || ""}
        title={title || name}
        style={boyut}
      />
    );
  }
  return (
    <span
      className="msj-avatar msj-avatar--initial"
      style={{ ...boyut, background: PALET[renkIndex(name)] }}
      title={title || name}
      aria-hidden="true"
    >
      {basHarf(name)}
    </span>
  );
}

// Küme (grup) avatarı — ilk 3 katılımcı üst üste.
export function AvatarGroup({ people = [], size = 30, max = 3 }) {
  const list = people.slice(0, max);
  return (
    <span className="msj-avatar-group">
      {list.map((p, i) => (
        <span
          key={p.id ?? i}
          className="msj-avatar-group-item"
          style={{ marginLeft: i === 0 ? 0 : -size * 0.38, zIndex: max - i }}
        >
          <Avatar name={p.display_name} src={p.avatar} size={size} />
        </span>
      ))}
      {people.length > max && (
        <span className="msj-avatar-more" style={{ width: size, height: size }}>
          +{people.length - max}
        </span>
      )}
    </span>
  );
}
